import { render, staticRenderFns } from "./unbindtel.vue?vue&type=template&id=52f74d88&scoped=true&"
import script from "./unbindtel.vue?vue&type=script&lang=js&"
export * from "./unbindtel.vue?vue&type=script&lang=js&"
import style0 from "./unbindtel.vue?vue&type=style&index=0&id=52f74d88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f74d88",
  null
  
)

export default component.exports